export default __webpack_public_path__ + "static/media/chat_question.d561c614.svg";